import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Gift } from "lucide-react";
import { typeformLinkProps } from "./TypeformModal";

const LetsChat = () => {
    return (
        <section id="lets-chat" data-testid="lets-chat-section" className="relative py-24 sm:py-28">
            <div className="mx-auto max-w-3xl px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="glass-panel relative overflow-hidden rounded-3xl px-8 py-12 text-center sm:px-12 glow-purple"
                >
                    <div className="absolute -left-16 -top-16 h-48 w-48 rounded-full bg-neon-purple/15 blur-[80px]" />
                    <div className="absolute -bottom-16 -right-16 h-48 w-48 rounded-full bg-neon-pink/15 blur-[80px]" />
                    <span className="relative mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-neon-purple to-neon-pink">
                        <MessageCircle size={22} className="text-white" />
                    </span>
                    <h2 className="font-display relative mt-6 text-2xl font-extrabold tracking-wide text-white sm:text-3xl">
                        LET&rsquo;S CHAT
                    </h2>
                    <p className="relative mt-4 text-base text-white/80 sm:text-lg">
                        Get in touch and we&rsquo;ll schedule a time for a quick demo.
                    </p>
                    <p className="relative mt-2 text-sm text-white/60">
                        Want a free step by step guide? Click below!
                    </p>
                    <a
                        {...typeformLinkProps}
                        data-testid="lets-chat-gift-button"
                        className="relative mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-neon-purple to-neon-pink px-7 py-3.5 text-sm font-bold text-white transition-transform duration-200 hover:scale-105 glow-pink"
                    >
                        <Gift size={16} />
                        Claim Your Gift Now
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default LetsChat;
